import React from "react";

function SubheadingElement (props){
    return(
        <><p className={props.classname}>{props.text}</p></>
    );
}

export default SubheadingElement;
